import { connect } from 'react-redux'

import userActions from 'actions/user'
import { getPromoCampaignIdFromPromoStoreEntry, getPromoStore } from 'selectors/promoStoreSelectors'
import { getUserOrders } from 'selectors/user'

import { BuildYourNextBox } from './BuildYourNextBox'

const mapSateToProps = (state: any) => {
  const promoStore = getPromoStore(state)
  const basketPromoCode = Object.keys(promoStore)[0]
  const campaignId = getPromoCampaignIdFromPromoStoreEntry(state, basketPromoCode)

  return {
    orders: getUserOrders(state).toJS(),
    campaignId: String(campaignId),
  }
}

export const BuildYourNextBoxContainer = connect(mapSateToProps, {
  userLoadOrders: userActions.userLoadOrders,
})(BuildYourNextBox)
